import React from 'react';
import Navbar from '../components/navbar';
import OpcionesInicio from '../components2/opcionesInicio';
import UserData from '../components/userData';
import ModalInicio from '../components2/modalInicio';

function Inicio() {
    return (
        <div className="flex flex-row w-full h-full">
            <ModalInicio />
            <div className="flex flex-col w-full h-full">
                <UserData />
                <OpcionesInicio />
            </div>
        </div>
    )
}

export default Inicio;